import guestGuard from "./../guards/guestGuard";

export default [
  {
    name: "login",
    path: "/login",
    component: () =>
      import(/* webpackChunkName: "chunks/login" */ "@views/Login"),
    beforeEnter: guestGuard,
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () =>
      import(
        /* webpackChunkName: "chunks/forget-password" */ "@views/ForgetPassword"
      ),
  },
  {
    path: "/reset-password/:token",
    name: "reset-password-form",
    component: () =>
      import(
        /* webpackChunkName: "chunks/reset-password-form" */ "@views/ResetPasswordForm"
      ),
  },
];
